// extracted by mini-css-extract-plugin
export default {"variants":"_1pf8p","label":"gDvKE","BoxSelectionOption":"_2kzqW","boxSelectionOption":"_2kzqW"};